import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { AuthContext } from 'context/AuthContext';
import { ContainsAnyRole } from 'utils/authHelpers';
import _ from 'lodash';

const AuthRoute = ({ container: Component, ...props }) => {
  const [routeProtected] = useState(props.requireAuth);
  const [requiredRoles] = useState(props.requiredRoles);
  const [granted, setGranted] = useState(undefined);
  const { sessionValid, user, sessionLoading } = useContext(AuthContext);

  if (!sessionLoading && granted === undefined && routeProtected === true) {
    if (sessionValid && _.isEmpty(requiredRoles)) {
      setGranted(true);
    } else if (user && sessionValid && ContainsAnyRole(requiredRoles, user.roles)) {
      setGranted(true);
    } else {
      setGranted(false);
    }
  }

  if (routeProtected === false || granted) {
    return <Component {...props} />;
  }
  if (granted === undefined) {
    return <div />;
  }
  return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
};

AuthRoute.propTypes = {
  container: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.object]).isRequired,
  requireAuth: PropTypes.bool,
  requiredRoles: PropTypes.array,
  location: PropTypes.object,
};

AuthRoute.defaultProps = {
  location: undefined,
  requireAuth: true,
  requiredRoles: [],
};

export default AuthRoute;
